export const InternalOnCallText = () => {
  return <div>You can Now Connect with Person On Call From the system.</div>;
};
